import React from "react";

import "./StudioHeaderControls.scss";

export const StudioHeaderControls = () => {
  return <></>;
};
